import styled, { css } from 'styled-components'
import { BodyMedium, BodyDefault, VerySmall } from "../typography/styled";
type ActiveProp = {
  active?:boolean,
  type?:string,
  isDark?:boolean
}

function styleMyEl(type:any) {
  switch (type) {
    case 'info':
    case 'information':
      return css`
        background-color: ${({theme}) => theme.isDark ? theme.palette[200] : theme.primary[40]};
      `;
    case 'error':
      return css`
        background-color: ${({theme}) => theme.isDark ? theme.palette[200] : theme.errors[100]};
      `;
    case 'warning':
      return css`
        background-color: ${({theme}) => theme.isDark ? theme.palette[200] : 'rgba(255, 209, 47, 0.1)'};
      `;
    default:
      return css`
        background-color: ${({theme}) => theme.isDark ? theme.palette[200] : theme.primary[40]};
      `;
  }
}

export const IconBackground = styled.div.withConfig({
  shouldForwardProp: (prop) => prop !== 'type',
})<ActiveProp>`
  ${({type}) => styleMyEl(type)};
  width:28px;
  height:28px;
  padding: 4px;
  margin-right: 8px;
  border-radius: ${({theme}) => theme.radius.control};
  box-sizing: border-box;

  img {
    display: block;
  }
`
export const Title = styled(BodyMedium)<ActiveProp>`
  color: ${({theme}) => theme.palette[900]};
  text-transform: capitalize;
`

export const TitleWrapper = styled.div`
  /* margin-top: 4px; */
  width: 100%;
  display:flex;
  flex-direction: column;
  gap: 2px;
`

export const CloseButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  flex: 0 0 20px;
  padding: 0;
  border: 0;
  background: transparent;
  color: ${({theme}) => theme.palette[800]};

  svg {
    width: 20px;
    height: 20px;
  }

  path {
    stroke: currentColor;
  }

  &:hover {
    cursor: pointer;
  }

  &:focus-visible {
    border-radius: ${({theme}) => theme.radius.xs};
    outline: none;
    box-shadow: ${({theme}) => theme.isDark ? theme.shadows.focusDark : theme.shadows.focus};
  }
`

export const Content = styled(BodyDefault)<ActiveProp>`
  color: ${({theme}) => theme.palette[650]};
  word-break: break-word;
`

export const ThinText = styled(VerySmall)`
  color:${({theme}) => theme.palette[650]};
`
type AlertPropsCustom = {
  isDark?:any;
  closing?:any;
  success?:boolean;
}
export const AlertCustom = styled.div<AlertPropsCustom>`
  width: 100%;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  justify-content: space-between;
  align-items: flex-start;
  padding: 9px;
  border: ${({theme}) => `1px solid ${theme.palette[20]}`};
  border-radius: ${({theme}) => theme.radius.card};
  box-shadow: ${({theme}) => theme.shadows.control};
  background-color: ${({theme}) => theme.palette[10]};
`;
